import Token from '@/utils/Token';
import Mask from '@/utils/Mask';

export default {
    parse(data) {
        ['ativo'].forEach(item => {
            data[item] = parseInt(data[item]);
        });

        ['documento'].forEach(item => {
            if(data[item]) {
                if(data.pessoa == 'J') {
                    data[item] = Mask.cnpj(data[item]);
                } else {
                    data[item] = Mask.cpf(data[item]);
                }
            }
        });

        return data;
    },

    get(id, params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/cliente/${id}${params}`, Token.getHeader());
    },
    list(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/cliente/list${params}`, Token.getHeader());
    },
    download(params="") {
        if(params) params = `?${params}`;
        const headers = Token.getHeader();
        headers.responseType = 'blob';

        return axios.get(`/api/cliente/download${params}`, headers);
    },
    total(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/cliente/total${params}`, Token.getHeader());
    },
    search(query) {
        return axios.get(`/api/cliente/search?query=${encodeURIComponent(query)}`, Token.getHeader());
    },
    create(params) {
        return axios.post(`/api/cliente`, params, Token.getHeader());
    },
    update(id,params) {
        return axios.post(`/api/cliente/${id}`, params, Token.getHeader());
    },
    delete(id) {
        return axios.delete(`/api/cliente/${id}`, Token.getHeader());
    },
}
